<template>
  <div class="box">
    <div class="p-5 border-b border-gray-200 dark:border-dark-5">
      <h2 class="font-medium text-base">{{ $t('text.customerInfoEmergencyContact') }}</h2>
    </div>
    <div class="">
      <div
        v-for="(v, index) in vForm.$each.$iter"
        :key="index"
        class="py-4 px-5 border-b border-gray-200 dark:border-dark-5 relative"
      >
        <InputSelect
          :label="$t('text.whoIsThisPerson')"
          :options="relationshipList"
          value-key="id"
          v-model.number="v.relationshipTypeId.$model"
          :vuelidate="v.relationshipTypeId"
        />
        <InputString
          :label="$t('text.firstName')"
          v-model.trim="v.name.$model"
          :vuelidate="v.name"
        />
        <InputString :label="$t('text.phone')" v-model.trim="v.phone.$model" :vuelidate="v.phone" />

        <div
          @click="confirmRemoval(index)"
          class="w-5 h-5 cursor-pointer flex items-center justify-center absolute rounded-full text-white bg-theme-6 right-0 top-0 -mr-2 mt-2"
        >
          <xIcon class="w-4 h-4" />
        </div>
      </div>
      <div class="py-4 px-5">
        <Button
          @click="$emit('add')"
          type="button"
          class=" border text-gray-700 dark:bg-dark-5 dark:text-gray-300 mr-3"
        >
          {{ $t('text.add') }}
        </Button>
      </div>
    </div>

    <ConfirmDialog :modal-id="deleteModalId" @ok="onDelete" />
  </div>
</template>

<script>
import InputString from '@/components/ui/input/InputString';
import InputSelect from '@/components/ui/input/InputSelect';
import Button from '@/components/ui/button/Button';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default {
  props: {
    form: Array,
    vForm: Object,
    relationshipList: Array,
  },

  components: {
    InputString,
    InputSelect,
    Button,
    ConfirmDialog,
  },

  data() {
    return {
      deleteModalId: 'delete-confirm-dialog',
      indexToRemove: null,
    };
  },

  methods: {
    confirmRemoval(index) {
      this.indexToRemove = parseInt(index, 10);
      cash(`#${this.deleteModalId}`).modal('show');
    },

    async onDelete() {
      await this.$emit('delete', this.indexToRemove);
      await cash(`#${this.deleteModalId}`).modal('hide');
      this.indexToRemove = null;
    },
  },
};
</script>
